// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue          from 'vue'
import App          from './App'
import store        from './store'


/* VueRouter */
import VueRouter    from 'vue-router';
// import {router}     from './routes/index.js'
import axios        from 'axios'

Vue.prototype.$http = axios;

Vue.use(VueRouter);

new Vue({
    el: '#app',
    render: h => h(App),
    // router,
    store
})


// WEBPACK FOOTER //
// ./src/main.js